import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=6435a636&scoped=true"
import script from "./ButtonLink.vue?vue&type=script&lang=js"
export * from "./ButtonLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435a636",
  null
  
)

export default component.exports